import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IPromotionsIconProps extends ISvgIconProps {

}

export class PromotionsIcon extends React.Component<IPromotionsIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5">
                    <path d="m7.734 12.12.912 2.15-3.224 1.368a1.167 1.167 0 0 1-1.53-.619l-1.14-2.686a1.167 1.167 0 0 1 .618-1.53l3.223-1.368.228.537" strokeLinecap="round" strokeWidth="1.5"/>
                    <path d="M8.645 14.272s5.827-1.206 9.002.3L12.63 2.753c-1.009 3.598-6.038 6.684-6.038 6.684" strokeLinecap="round" strokeWidth="1.5"/>
                    <path d="M5.153 15.75 9.24 20.63a.874.874 0 0 0 1.013.244l2.357-1a.583.583 0 0 0 .309-.766l-.196-.46a1.457 1.457 0 0 0-.437-.575l-2.078-1.644a3.502 3.502 0 0 1-.823-.935l-.74-1.228" strokeWidth="1.5"/>
                    <path strokeLinecap="round" d="m18.24 7.273 1.575-.67" strokeWidth="1.5"/>
                    <path strokeLinecap="round" d="m19.674 10.498 1.623.655" strokeWidth="1.5"/>
                    <path strokeLinecap="round" d="m16.968 4.12.655-1.623" strokeWidth="1.5"/>
                </g>
            </SvgIcon>
        );
    }
}
